module.exports = __webpack_public_path__ + "static/img/ZRS1566_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ZRS1566_1.png
// module id = JeaR
// module chunks = 0